module.exports = __webpack_public_path__ + "static/media/background.03b111f5.png";